import { useEffect, useRef, useState } from "react";
import { ReactComponent as ChevronDownIcon } from "../../../assets/icons/chevron-down.svg";
import { ReactComponent as CheckMarkIcon } from "../../../assets/icons/check-mark.svg";
import moment from "moment";
import { ReactComponent as DotsIcon } from "../../../assets/icons/dots.svg";

const getDates = (value: string) => {
  if (value === "l9n3") {
    // send last 9 months and next 3 months
    const currentYear = new Date().getFullYear();
    const startDate = moment()
      .set("year", currentYear)
      .subtract(9, "months")
      .format("YYYY-MM-DD");
    const endDate = moment()
      .set("year", currentYear)
      .add(3, "months")
      .format("YYYY-MM-DD");
    return {
      startDate,
      endDate,
      year: value,
    };
  }
  // send the year start and end date
  const currentYear = Number(value);
  const startDate = moment()
    .set("year", currentYear)
    .startOf("year")
    .format("YYYY-MM-DD");
  const endDate = moment()
    .set("year", currentYear)
    .endOf("year")
    .format("YYYY-MM-DD");
  return {
    startDate,
    endDate,
    year: `${currentYear}`,
  };
};

const getYearOptions = () => {
  const options = [
    {
      label: "Current Week",
      value: "CURRENT_WEEK",
    },
    {
      label: "Current Month",
      value: "CURRENT_MONTH",
    },
    {
      label: "Current Year",
      value: "CURRENT_YEAR",
    },
  ];

  return options;
};

export function UserOptionSelect({
  onDeactivate,
  onDelete,
}: {
  onDeactivate?: () => void;
  onDelete?: () => void;
}) {
  const [showFilter, setShowFilter] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Implement outside click handler
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !(containerRef.current as HTMLElement).contains(event.target as Node)
      ) {
        setShowFilter(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={containerRef} className="relative">
      <button type="button" onClick={() => setShowFilter((p) => !p)}>
        <DotsIcon className="w-6 h-6" />
      </button>
      {showFilter && (
        <div
          className={`absolute z-[1] right-0 mt-1 p-1 bg-white rounded shadow border border-[#e8e8ea] flex-col justify-start items-start gap-1.5 flex`}
        >
          <div className="self-stretch max-h-[100px] flex-col justify-start items-start flex">
            <button
              onClick={onDeactivate}
              type="button"
              className="self-stretch hover:bg-[#f2f1ff] h-[25px] p-2 rounded-sm justify-between items-center gap-2 flex"
            >
              <div
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>

                className="text-[#161938] text-xs font-medium leading-3 whitespace-nowrap"
              >
                Deactivate
              </div>
            </button>
            <button
              onClick={onDelete}
              type="button"
              className="self-stretch hover:bg-[#f2f1ff] h-[25px] p-2 rounded-sm justify-between items-center gap-2 flex"
            >
              <div className="text-[#161938] text-xs font-medium leading-3 whitespace-nowrap">
                Delete
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
